/** Industry pill colors aligned with dashboard reference UI. */
const INDUSTRY_PILL_BY_KEY: Record<string, { bg: string; color: string }> = {
  ICT_AND_DIGITAL_TECH: { bg: "#e0f2fe", color: "#04305c" },
  AGRICULTURE_AND_FOOD_PROCESSING: { bg: "#dcfce7", color: "#166534" },
  HEALTHCARE_AND_LIFE_SCIENCES: { bg: "#ffe4e6", color: "#9f1239" },
  OIL_AND_GAS: { bg: "#ffedd5", color: "#1e293b" },
  DEFENCE_AND_AEROSPACE: { bg: "#ede9fe", color: "#5b21b6" },
  SHIPPING_MARITIME_PORTS: { bg: "#cffafe", color: "#0e7490" },
  POWER_AND_ENERGY: { bg: "#fef9c3", color: "#a16207" },
  MANUFACTURING_AND_INDUSTRIAL_AUTOMATION: { bg: "#e2e8f0", color: "#334155" },
  ELECTRONICS_AND_SEMICONDUCTORS: { bg: "#e0e7ff", color: "#3730a3" },
  AUTOMOTIVE_AND_EV: { bg: "#f3e8ff", color: "#6b21a8" },
  CHEMICALS_AND_SPECIALTY_MATERIALS: { bg: "#ffedd5", color: "#c2410c" },
  MINING: { bg: "#f5f5f4", color: "#44403c" },
  METALS_AND_MINERALS: { bg: "#f1f5f9", color: "#475569" },
  CONSTRUCTION_AND_EPC: { bg: "#fef3c7", color: "#92400e" },
  WATER_AND_ENVIRONMENTAL_SOLUTIONS: { bg: "#ccfbf1", color: "#0f766e" },
  CLIMATE_TECH_AND_SUSTAINABILITY: { bg: "#d1fae5", color: "#047857" },
  INDUSTRIAL_MACHINERY_TOOLS_AND_CAPITAL_EQUIPMENT: { bg: "#e2e8f0", color: "#1e293b" },
  PLASTICS_POLYMERS_AND_RUBBER_MANUFACTURING: { bg: "#fce7f3", color: "#9d174d" },
  CONSUMER_PRODUCTS_AND_FMCG: { bg: "#fff7ed", color: "#c2410c" },
  TEXTILES_APPAREL_AND_TECHNICAL_FABRICS: { bg: "#fdf2f8", color: "#be185d" },
  PACKAGING_PRINTING_AND_CONVERTING_SOLUTIONS: { bg: "#f0fdf4", color: "#15803d" },
};

const FALLBACK_PILL_PALETTES = [
  { bg: "#e0f2fe", color: "#0369a1" },
  { bg: "#dcfce7", color: "#15803d" },
  { bg: "#ede9fe", color: "#6d28d9" },
  { bg: "#fce7f3", color: "#be185d" },
  { bg: "#ffedd5", color: "#c2410c" },
  { bg: "#ccfbf1", color: "#0f766e" },
] as const;

function hashSeed(seed: string): number {
  let h = 0;
  for (let i = 0; i < seed.length; i += 1) {
    h = (h << 5) - h + seed.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
}

export function industryPillStyleForKey(industryKey: string) {
  const palette = INDUSTRY_PILL_BY_KEY[industryKey];
  if (palette) {
    return { backgroundColor: palette.bg, color: palette.color };
  }
  const fallback = FALLBACK_PILL_PALETTES[hashSeed(industryKey) % FALLBACK_PILL_PALETTES.length];
  return { backgroundColor: fallback.bg, color: fallback.color };
}
